import { render, staticRenderFns } from "./BoxEntriesHeaderTitle.vue?vue&type=template&id=4ed51c92&"
import script from "./BoxEntriesHeaderTitle.vue?vue&type=script&lang=ts&"
export * from "./BoxEntriesHeaderTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports